import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import moment from 'moment';
import Avatar from 'react-avatar';
import { useTranslation } from 'react-i18next';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { uploadFile } from 'store/actions/auth.action';
import { REGISTRAR_LIST } from 'store/actions/types';
import errorMessages from 'utils/errorMessages';
import { createUserAction, deleteUserAction, getMyProfile, getRolesAction, getUserListAction, updateUserAction, updateUserPrivilegesAction } from '../../../store/actions/user.action';
import { RootState } from '../../../store/reducers';
import '../../../styles/dashboard/admin.scss';
import { Logout, checkRoleById, generateIntegrationLink, getUIRoleType, getUserImageURL, handleToast, isValidEmail, isValidUrl, roles, splitName } from '../../../utils/handler';
import successMessages from '../../../utils/successMessages';
import { NumberInput, ReactPagination } from '../../components/CommonPages';
import { roleType, updateUserType, userRoles, userType } from '../../types/user.types';

const initialUserDetails = {
  lastLogin: '',
  UID: '',
  closeAgentUID: '',
  createdAt: '',
  email: '',
  image: '',
  name: '',
  phone: '',
  role: { UID: '', roleType: '' },
  roles: [{ roleUID: '' }],
  roleId: '',
  userInterested: '',
  firstName: '',
  lastName: '',
  website: '',
};
const privilegesInitial = {
  AppraisalSearchUnLimit: true,
  ShareDownloadAppraisal: true,
  EmailAppraisalCertificate: true,
  WeeklyAppraisalSearchHistoryReport: false,
  ChangeAppraisedDomainValues: false,
  ChangeCategoryValues: false,
  percentage: 20,
  commissionPercentage: 20,
};
let initialUserList: userType[] = [];
let initialRolesList: roleType[] = [];
let searchFilter: any = null;
export const UserSettings: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const [userList, setUserList] = useState<userType[]>(initialUserList);
  const [rolesList, setRolesList] = useState<roleType[]>(initialRolesList);
  const [popupType, setPopupType] = useState('');
  const [image, setImage] = useState<File>();
  const [phoneValidationError, setPhoneValidationError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [userDetails, setUserDetails] = useState<userType>(initialUserDetails);
  const [privileges, setPrivileges] = useState(privilegesInitial);
  const { myProfile, registrarList } = useSelector((state: RootState) => state.userReducer);
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);
  const [pagination, setPagination] = useState({
    count: 0,
    limit: 10,
    page: 1,
    totalPages: 1,
  });

  const checkRole = (userRoles: userRoles[], roles: roleType[], checkRole: string) => {
    let isRole = false;
    let roleId = '';
    if (roles && Array.isArray(roles) && roles.length > 0) {
      for (const role of roles) {
        if (role.roleType === checkRole) {
          roleId = role.UID;
          break;
        }
      }
    }
    if (userRoles && Array.isArray(userRoles) && userRoles.length > 0) {
      for (const userRole of userRoles) {
        if (userRole.roleUID === roleId) {
          isRole = true;
          break;
        }
      }
    }
    return isRole;
  };

  const [filter, setFilter] = useState({ search: '', filterBy: '', filterType: '', sortBy: 'createdAt', sortType: 'DESC', limit: 10, page: 1 });
  const dispatch = useDispatch();
  useEffect(() => {
    getUserList();
    getRoleList();
  }, []);

  const getRoleList = () => {
    getRolesAction().then((response) => {
      if (response) {
        initialRolesList = _.sortBy(response, 'roleType');
        setRolesList(initialRolesList);
      }
    });
  };

  const getUserList = (payload?: { search?: string; filterBy?: string; filterType?: string; sortBy?: string; sortType?: string; limit?: number; page?: number }) => {
    // let { search = "", filterBy = "", filterType = "", sortBy = "createAt", sortType = "DESC", limit = 10, page = 1 } = filters
    getUserListAction({ ...filter, ...payload }).then((response) => {
      if (response) {
        initialUserList = response.users;
        setUserList(initialUserList);
        setPagination(response.pagination);
      }
    });
  };
  const submitForm = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkFormValid()) {
      let imageName = '';
      if (image) {
        imageName = await uploadFile(image);
      }
      let payload: updateUserType = {
        name: userDetails.firstName + (userDetails.lastName ? ' ' + userDetails.lastName : ''),
        roleId: userDetails.roleId,
        phone: userDetails.phone || '',
        website: userDetails.website || '',
      };
      if (imageName) {
        payload.image = imageName;
      }
      if (popupType === 'Edit User') {
        updatePrivileges(userDetails.UID);
        updateUserAction(payload, userDetails.UID).then((message) => {
          if (message) {
            handleToast({ message }, 'success');
            if (userDetails.UID === myProfile.UID && userDetails.roleId !== myProfile.roleId) {
              Logout();
            } else {
              getUserList();
              setPopupType('');
            }
          }
        });
      } else {
        payload.email = userDetails.email;
        createUserAction(payload).then((response) => {
          if (response) {
            handleToast({ message: successMessages.userCreatedSuccessfully }, 'success');
            setPopupType('');
            getUserList();
            updatePrivileges(response.UID);
          }
        });
      }
    }
  };
  const updatePrivileges = (userUID: string) => {
    let privilegePayload = {
      AppraisalSearchUnLimit: privileges.AppraisalSearchUnLimit || false,
      ShareDownloadAppraisal: privileges.ShareDownloadAppraisal || false,
      EmailAppraisalCertificate: privileges.EmailAppraisalCertificate || false,
      WeeklyAppraisalSearchHistoryReport: privileges.WeeklyAppraisalSearchHistoryReport || false,
      ChangeAppraisedDomainValues: privileges.ChangeAppraisedDomainValues || false,
      ChangeCategoryValues: privileges.ChangeCategoryValues || false,
      percentage: privileges.percentage || 20,
      commissionPercentage: privileges.commissionPercentage || 20,
    };
    updateUserPrivilegesAction(privilegePayload, userUID).then((response) => {
      if (response) {
        if (userUID === myProfile.UID) {
          getMyProfile();
          if (checkRoleById(userDetails.roleId) === roles.registrar) {
            registrarList.forEach((user: userType) => {
              if (user.UID === userUID && user.userDetail) {
                user.userDetail.percentage = privilegePayload.percentage;
              }
            });
            dispatch({ type: REGISTRAR_LIST, payload: registrarList });
          }
        }
      }
    });
  };
  const handleUserChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
  };

  const phoneNumberChange = (value: any) => {
    if (!value || (value && isValidPhoneNumber(value))) {
      setPhoneValidationError('');
    }
    if (value && !isValidPhoneNumber(value)) {
      setPhoneValidationError('Invalid phone number');
    }
    setUserDetails({ ...userDetails, phone: value });
  };
  const checkFormValid = () => {
    let { email = '', roleId = '', firstName, website = '' } = userDetails;
    setFormSubmitted(true);
    if (!firstName) {
      return false;
    }
    if (!email) {
      return false;
    }
    if (isValidEmail(email)) {
      return false;
    }
    if (website && !isValidUrl(website)) {
      handleToast({ message: 'Please enter valid URL' });
      return false;
    }
    if (roleId === '') {
      return false;
    }
    if (privileges.percentage && privileges.percentage > 100) {
      handleToast({ message: errorMessages.commissionBelow100 });
      return false;
    }
    if (privileges.commissionPercentage && privileges.commissionPercentage > 100) {
      handleToast({ message: errorMessages.commissionBelow100 });
      return false;
    }
    if (userDetails.phone && !isValidPhoneNumber(userDetails.phone)) {
      setPhoneValidationError('Invalid phone number');
      return false;
    }
    if (phoneValidationError) {
      return false;
    }
    return true;
  };

  const handlePrivilegesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPrivileges({ ...privileges, [e.target.name]: e.target.checked });
  };
  const deleteUser = (UID: string) => {
    if (window.confirm('Are you sure you want to delete this User')) {
      deleteUserAction(UID).then((response) => {
        if (response) {
          getUserList();
        }
      });
    }
  };
  const onPageChange = (pageNumber: number) => {
    setFilter((prev) => ({ ...prev, page: pageNumber }));
    getUserList({ page: pageNumber });
  };
  const sortUser = (sortBy: string) => {
    setFilter((prev) => ({ ...prev, sortBy, sortType: prev.sortType === 'DESC' ? 'ASC' : 'DESC' }));
    getUserList({ sortBy });
  };
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter((prev) => ({ ...prev, page: 1, search: e.target.value }));
    if (searchFilter) {
      clearTimeout(searchFilter);
    }
    searchFilter = setTimeout(function () {
      getUserList({ page: 1, search: e.target.value });
    }, 500);
  };
  const onFileChange = (fileList: FileList | null) => {
    if (fileList && fileList?.length > 0) {
      setImage(fileList[0]);
      let imageURL = URL.createObjectURL(fileList[0]);
      setUserDetails({ ...userDetails, image: imageURL });
    }
  };
  return (
    <div className=" no-header clearfix">
      <input
        type="file"
        id="Upload-image"
        onChange={(e) => {
          onFileChange(e.target.files);
          e.target.value = '';
        }}
        className="d-none"
      />
      <div className="d-flex align-items-center px-2 py-1 justify-content-sm-between flex-column flex-sm-row">
        <input type="text" className="form-control admin-search" id="search" name="search" value={filter.search} onChange={onSearch} placeholder="search by name and email" required />
        <button
          className="float-right btn btn-primary mx-auto ml-sm-auto mr-sm-0 mt-2 mt-sm-0 text-nowrap"
          onClick={() => {
            setImage(undefined);
            setUserDetails(initialUserDetails);
            setFormSubmitted(false);
            setPopupType('Create user');
            setPrivileges(privilegesInitial);
          }}
        >
          <i className="fa fa-plus mr-2"></i>Add account
        </button>
      </div>
      <div className="main-box-body clearfix">
        <div className="table-responsive">
          <table className="table user-list table text-center table table-hover ">
            <thead>
              <tr>
                <th>
                  {' '}
                  User <i className="ml-2 fa-solid fa-sort" onClick={() => sortUser('name')}></i>
                </th>
                <th>
                  Phone <i className="ml-2 fa-solid fa-sort" onClick={() => sortUser('phone')}></i>
                </th>
                <th>
                  {' '}
                  Email <i className="ml-2 fa-solid fa-sort" onClick={() => sortUser('email')}></i>
                </th>
                <th className="text-nowrap">
                  Created At <i className="ml-2 fa-solid fa-sort" onClick={() => sortUser('createdAt')}></i>{' '}
                </th>
                <th className="text-nowrap">
                  Last Login <i className="ml-2 fa-solid fa-sort" onClick={() => sortUser('lastLogin')}></i>{' '}
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {userList &&
                userList.map((user: userType, index: number) => {
                  let isConsultant = false;
                  let isRegistrar = false;
                  let registrarUID = '';
                  let consultantUID = '';
                  if (rolesList && Array.isArray(rolesList)) {
                    rolesList.forEach((item) => {
                      if (item.roleType === roles.registrar) registrarUID = item.UID;
                      if (item.roleType === roles.consultant) consultantUID = item.UID;
                    });
                  }
                  if (user.roles && Array.isArray(user.roles)) {
                    user.roles.forEach((item) => {
                      if (item?.roleUID === registrarUID) isRegistrar = true;
                      if (item?.roleUID === consultantUID) isConsultant = true;
                    });
                  }
                  return (
                    <Fragment key={index}>
                      <tr className="table-stripe-color">
                        <td className="d-flex text-left">
                          <div className="mr-2 flex-shrink-0">
                            <Avatar size={'40'} className="agent-dashboard-size" textSizeRatio={2} round={true} src={getUserImageURL(user?.image)} name={user.name} />
                          </div>
                          <div className="">
                            <div className="text-nowrap">{user.name}</div>
                            {user.roles &&
                              Array.isArray(user.roles) &&
                              user.roles.map((item, i) => (
                                <span key={i} className="user-subhead">
                                  {isConsultant ? 'Domain Broker' : user?.role?.roleType}
                                </span>
                              ))}
                          </div>
                        </td>
                        <td className="text-nowrap">{user.phone || '-'}</td>
                        <td className="text-left">{user.email}</td>
                        <td className="text-nowrap">{moment(user.createdAt).isValid() ? moment(user.createdAt).format('lll') : '-'}</td>
                        <td className="text-nowrap">{moment(user.lastLogin).isValid() ? moment(user.lastLogin).format('lll') : '-'}</td>
                        <td className="action-column text-nowrap">
                          <i
                            onClick={() => {
                              setImage(undefined);
                              setPopupType('Edit User');
                              setFormSubmitted(false);
                              const roleId = user?.roles?.[0]?.roleUID || '';
                              setUserDetails({ ...user, roleId, ...splitName(user.name) });
                              setPrivileges(user.userDetail || privilegesInitial);
                            }}
                            className="fa-solid fa-pencil text-warning mr-3 c-pointer"
                          ></i>
                          <i className="fa-solid fa-trash text-danger c-pointer  mr-3" onClick={() => deleteUser(user.UID)}></i>
                          {isRegistrar && <i className="fa-solid fa-lg fa-clipboard text-primary-dark " onClick={() => generateIntegrationLink(user.UID)}></i>}
                        </td>
                      </tr>
                      <td colSpan={6}>
                        <div className="text-left">
                          <span>Buy Domains: </span>
                          <span>{user.buyDomain && user.buyDomain.length > 0 ? user.buyDomain.join(', ') : 'No Submission'}</span>
                        </div>
                        <div className="text-left">
                          <span>Appraised Domains: </span>
                          <span>{user.appraisedDomain && user.appraisedDomain.length > 0 ? user.appraisedDomain.join(', ') : 'No Submission'}</span>
                        </div>
                        <div className="text-left">
                          <span>Sell Domains: </span>
                          <span>{user.sellDomain && user.sellDomain.length > 0 ? user.sellDomain.join(', ') : 'No Submission'}</span>
                        </div>
                      </td>
                    </Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
        <ReactPagination currentPage={filter.page} totalPages={pagination.totalPages} onPageChange={onPageChange} />
      </div>
      {popupType !== '' && (
        <div className="popup ">
          <div className="popup-header">
            <span className="popup-name fs-21 f-bold">{popupType}</span>
            <i className="fa fa-times fa-lg text-danger float-right" onClick={() => setPopupType('')}></i>
          </div>
          <div className="popup-body">
            <div className="row justify-content-center  position-relative p-2">
              <div>
                <div className="d-flex justify-content-center">
                  {/* <img src={getUserImageURL(userDetails?.image) || 'https://graph.facebook.com/100008343750912/picture?width=300&height=300'}
                  className="edit-user-image c-pointer" alt="Img" onClick={() => document.getElementById('Upload-image')?.click()}></img> */}
                  <Avatar className="edit-user-image c-pointer" textSizeRatio={3} onClick={() => document.getElementById('Upload-image')?.click()} src={getUserImageURL(userDetails.image || 'https://graph.facebook.com/100008343750912/picture?width=300&height=300')} name={userDetails.name} />
                </div>
                <div className="edit-img ">
                  Edit Image
                  <i className="ml-3 fa fa-pencil  text-primary" onClick={() => document.getElementById('Upload-image')?.click()}></i>
                </div>
              </div>
            </div>
            <form noValidate className={'row profile-form m-0 ' + (formSubmitted ? ' was-validated' : ' ')} onSubmit={submitForm}>
              <div className="mb-3 col-6">
                <label className="form-label">First Name</label>
                <input type="text" className="form-control" id="firstName" name="firstName" value={userDetails.firstName} onChange={handleUserChange} required />
                <div className="invalid-feedback">{t('Please Enter User Name')}</div>
              </div>
              <div className="mb-3 col-6">
                <label className="form-label">Last Name</label>
                <input type="text" className="form-control" id="lastName" name="lastName" value={userDetails.lastName} onChange={handleUserChange} />
                <div className="invalid-feedback">{t('Please Enter User Name')}</div>
              </div>
              <div className="mb-3 col-6">
                <label className="form-label">Phone</label>
                <PhoneInput international defaultCountry={localCountryStr} placeholder="Enter phone number" value={userDetails.phone || undefined} onChange={(data) => phoneNumberChange(data || '')} className="form-control" />
                {formSubmitted && userDetails.phone && !isValidPhoneNumber(userDetails.phone) ? <div className="text-danger">{t('Invalid phone number')}</div> : null}
              </div>
              <div className="mb-3 col-6">
                <label className="form-label">Email</label>
                <input type="email" disabled={popupType === 'Edit User'} className={'form-control ' + (!isValidEmail(userDetails.email) ? ' ' : '')} id="email" name="email" value={userDetails.email} onChange={handleUserChange} required />
                <div className="invalid-feedback">{t('Please Enter Valid Email')}</div>
              </div>

              <div className="mb-3 col-6">
                <label className="form-label">User Role</label>
                <select id="statementType " name="roleId" value={userDetails.roleId} onChange={handleUserChange} className="form-control" required>
                  <option selected value={''} disabled>
                    Choose Type
                  </option>
                  {rolesList.map((role: roleType, index: number) => (
                    <option key={index} value={role.UID}>
                      {getUIRoleType(role.roleType)}
                    </option>
                  ))}
                </select>
              </div>
              {checkRole(userDetails.roles, rolesList, roles.registrar) ? (
                <>
                  <div className="mb-3 col-6">
                    <label className="form-label">Website URL</label>
                    <input type="url" pattern="https://.*" size={30} placeholder="https://example.com" className={'form-control ' + (userDetails.website && !isValidUrl(userDetails.website) ? ' valid ' : '')} id="website" name="website" value={userDetails.website} onChange={handleUserChange} required />
                    {userDetails.website ? <div className="invalid-feedback">{t('Please Enter Valid website')}</div> : null}
                  </div>

                  <div className="mb-3 col-6">
                    <label className="form-label">Initial Fee Percentage</label>
                    <NumberInput
                      placeholder="Percentage"
                      value={privileges?.percentage || ''}
                      min={0}
                      max={100}
                      name="percentage"
                      onChange={(e) => {
                        setPrivileges({ ...privileges, percentage: Number(e.target.value) });
                      }}
                    />
                    <div className="invalid-feedback">{t('Please Enter Valid Percentage')}</div>
                  </div>
                  <div className="mb-3 col-6">
                    <label className="form-label">Sales Commission Percentage</label>
                    <NumberInput
                      placeholder="commissionPercentage"
                      value={privileges?.commissionPercentage || ''}
                      min={0}
                      max={100}
                      name="percentage"
                      onChange={(e) => {
                        setPrivileges({ ...privileges, commissionPercentage: Number(e.target.value) });
                      }}
                    />
                    <div className="invalid-feedback">{t('Please Enter Valid Commission Percentage')}</div>
                  </div>
                </>
              ) : null}
            </form>
            {userDetails.roles.length > 0 && (
              <div className="">
                <div className="fs-21 f-bold">User privileges - Appraisals</div>
                <div className="container admin permission-container row">
                  <div className="form-check">
                    <input className="form-check-input is-invalid" type="checkbox" onChange={handlePrivilegesChange} name="AppraisalSearchUnLimit" checked={privileges.AppraisalSearchUnLimit} id="invalidCheck1" aria-describedby="invalidCheck1Feedback" required />
                    <label className="form-check-label" htmlFor="invalidCheck3">
                      No limit on Appraisal search
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input is-invalid" type="checkbox" onChange={handlePrivilegesChange} name="ShareDownloadAppraisal" checked={privileges.ShareDownloadAppraisal} id="invalidCheck2" aria-describedby="invalidCheck2Feedback" required />
                    <label className="form-check-label" htmlFor="invalidCheck3">
                      Share/Download - Appraisal
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input is-invalid" type="checkbox" onChange={handlePrivilegesChange} name="EmailAppraisalCertificate" checked={privileges.EmailAppraisalCertificate} id="invalidCheck2" aria-describedby="invalidCheck2Feedback" required />
                    <label className="form-check-label" htmlFor="invalidCheck3">
                      Email appraisal certificate
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input is-invalid" type="checkbox" onChange={handlePrivilegesChange} name="WeeklyAppraisalSearchHistoryReport" checked={privileges.WeeklyAppraisalSearchHistoryReport} id="invalidCheck2" aria-describedby="invalidCheck2Feedback" required />
                    <label className="form-check-label" htmlFor="invalidCheck3">
                      Weekly appraisal search history report
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input is-invalid" type="checkbox" onChange={handlePrivilegesChange} name="ChangeAppraisedDomainValues" checked={privileges.ChangeAppraisedDomainValues} id="invalidCheck2" aria-describedby="invalidCheck2Feedback" required />
                    <label className="form-check-label" htmlFor="invalidCheck3">
                      Change appraised domain values
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input is-invalid" type="checkbox" name="ChangeCategoryValues" checked={privileges.ChangeCategoryValues} onChange={handlePrivilegesChange} id="invalidCheck2" aria-describedby="invalidCheck2Feedback" required />
                    <label className="form-check-label" htmlFor="invalidCheck3">
                      Change category values
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="popup-footer">
            <button type="button" className=" btn btn-primary" onClick={submitForm}>
              Submit
            </button>
            <button type="button" className="ms-2 btn btn-danger" onClick={() => setPopupType('')}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
